<template>
  <v-breadcrumbs class="text-body-medium" :items density="compact">
    <template #prepend>
      <v-btn variant="text" icon :to="homeTo" :active="false" density="compact">
        <v-icon icon="far fa-house" size="14" />
      </v-btn>
      <v-breadcrumbs-divider class="pl-1">/</v-breadcrumbs-divider>
      <template v-if="hasMultipleSpaces">
        <div class="pl-1">
          <TheAppSpaceSelect />
        </div>
        <v-breadcrumbs-divider class="pl-3">/</v-breadcrumbs-divider>
      </template>
    </template>
    <template #item="{ item, index }">
      <v-btn
        v-if="index === 0"
        variant="text"
        class="text-body-medium font-weight-medium px-2 mx-n1"
        density="compact"
        min-width="0"
        :to="homeRoute"
        :active="false"
      >
        {{ item?.title }}
      </v-btn>
      <span
        v-else
        class="text-no-wrap"
        :class="{
          'font-weight-normal opacity-70': index === items.length - 1,
          'text-truncate': index < items.length - 1,
        }"
      >
        {{ item?.title }}
      </span>
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { useAppBreadcrumbs } from '@/composables/use-app-breadcrumbs'
import { useCurrentSpace, useSpaces } from '@/composables/use-spaces'
import TheAppSpaceSelect from './TheAppSpaceSelect.vue'

const { items: allItems, homeRoute } = useAppBreadcrumbs()
const { xs } = useDisplay()
const { hasMultipleSpaces } = useSpaces()
const { currentSpaceConfig, currentSpaceParam } = useCurrentSpace()

const homeTo = computed(() => {
  const name = currentSpaceConfig.value.home
  return name.includes('[[space]]')
    ? { name, params: { space: currentSpaceParam.value } }
    : { name }
})

const items = computed(() => {
  if (xs.value && allItems.value.length > 2) {
    return ['...', allItems.value.at(-1) ?? '']
  }
  return allItems.value
})
</script>

<style scoped lang="css">
:deep(.v-breadcrumbs-divider) {
  opacity: 0.4;
}
</style>
